// menu-dropdown.js
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.header__inline-menu details');

  menuItems.forEach(item => {
    // Al pasar el ratón, abre el <details>
    item.addEventListener('mouseenter', () => {
      item.open = true;
    });

    // Al salir, cierra el <details>
    item.addEventListener('mouseleave', () => {
      item.open = false;
    });
  });
});
